import { IFilterComplete } from '../../filter-complete/filter-complete';
export class BillingInvoicePeriod implements IFilterComplete {
    public Name: string;
    public Id: number;
}
